module.exports = __webpack_public_path__ + "static/media/01_before.8eda6ec7.jpg";